// redux/actions/journeyAction.js
import storeApis from "../../api/storeApi";
import { toast } from "react-toastify";
import {
  FETCH_JOURNEY_DATA,
  TOGGLE_LOADING,
  UNAUTHORIZED_SETUP,
  DELETE_JOURNEY_DATA,
  FETCH_JOURNEY_DETAIL,
  SET_CURRENT_PAGE,
  SET_ITEMS_PER_PAGE,
  SET_SEARCH_TERM,
  SET_FILTERS,
  CLEAR_FILTERS,
  UPDATE_PAGINATION_TOTALS,
  SET_SEGMENT_CURRENT_PAGE,
  SET_SEGMENT_ITEMS_PER_PAGE,
  UPDATE_SEGMENT_PAGINATION_TOTALS,
  JOURNEY_CREATE,
  FETCH_SEGMENTS_REQUEST,
  FETCH_SEGMENTS_SUCCESS,
  FETCH_SEGMENTS_FAILURE,
  GET_SEGMENT_REQUEST,
  GET_SEGMENT_SUCCESS,
  GET_SEGMENT_FAILURE,
  CREATE_SEGMENT_REQUEST,
  CREATE_SEGMENT_SUCCESS,
  CREATE_SEGMENT_FAILURE,
  SCHEDULE_JOURNEY_REQUEST,
  SCHEDULE_JOURNEY_SUCCESS,
  SCHEDULE_JOURNEY_FAILURE,
  FETCH_MASTER_LIST_REQUEST,
  FETCH_MASTER_LIST_SUCCESS,
  FETCH_MASTER_LIST_FAILURE,
  SEND_TEST_EMAIL_REQUEST,
  SEND_TEST_EMAIL_SUCCESS,
  SEND_TEST_EMAIL_FAILURE,
  JOURNEY_UPDATE_REQUEST,
  JOURNEY_UPDATE_SUCCESS,
  JOURNEY_UPDATE_FAILURE,
  JOURNEY_CREATE_REQUEST,
  JOURNEY_CREATE_SUCCESS,
  JOURNEY_CREATE_FAILURE,
  DELETE_SEGMENT_DATA,
  PUBLISH_SEGMENT_DATA,
  COPY_SEGMENT_DATA,
  COPY_JOURNEY_REQUEST,
  COPY_JOURNEY_SUCCESS,
  COPY_JOURNEY_FAILURE,
  COUNT_USERS_REQUEST,
  COUNT_USERS_SUCCESS,
  COUNT_USERS_FAILURE,
  FILTER_DROPDOWN_DATA,
  FILTER_DROPDOWN_DATA_SUCCESS,
  FILTER_DROPDOWN_DATA_FAILURE,
  FETCH_WHATSAPP_TEMPLATE_LIST_REQUEST,
  FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS,
  FETCH_WHATSAPP_TEMPLATE_LIST_FAILURE,
  WHATSAPP_TEMPLATE_UPDATE_REQUEST,
  WHATSAPP_TEMPLATE_UPDATE_SUCCESS,
  WHATSAPP_TEMPLATE_UPDATE_FAILURE,
  NOTIFICATION_DETAIL_LIST_REQUEST,
  NOTIFICATION_DETAIL_LIST_SUCCESS,
  NOTIFICATION_DETAIL_LIST_FAILURE,
  FETCH_VERIFIED_EMAIL_LIST_REQUEST,
  FETCH_VERIFIED_EMAIL_LIST_SUCCESS,
  FETCH_VERIFIED_EMAIL_LIST_FAILURE
} from "../../constants/ActionTypes";

// ✅ API Endpoints
const JOURNEY_LIST_URL = "/framework/api/journeyBuilder/list";
const JOURNEY_DELETE_URL = "/framework/api/journeyBuilder/delete-journey";
const JOURNEY_DETAIL_URL = "/framework/api/journeyBuilder/details";
const JOURNEY_CREATE_URL = "/framework/api/journeyBuilder/create-journey";
const JOURNEY_UPDATE_URL = "/framework/api/journeyBuilder/create-steps";
const WHATSAPP_TEMPLATE_LIST_URL = "/framework/api/whatsAppTemplateList";
const WHATSAPP_TEMPLATE_UPDATE_URL = "/framework/api/journeyBuilder/createNotification";
const NOTIFICATION_DETAIL_LIST_URL = "/framework/api/journeyBuilder/notificationDetailList";
const VERIFIED_EMAIL_LIST_URL = "/framework/api/journeyBuilder/verifiedEmailList";


// ---------------------- Template Actions ----------------------

// Template Action Types
export const FETCH_TEMPLATES_REQUEST = "FETCH_TEMPLATES_REQUEST";
export const FETCH_TEMPLATES_SUCCESS = "FETCH_TEMPLATES_SUCCESS";
export const FETCH_TEMPLATES_FAILURE = "FETCH_TEMPLATES_FAILURE";

export const FETCH_TEMPLATE_DETAIL_REQUEST = "FETCH_TEMPLATE_DETAIL_REQUEST";
export const FETCH_TEMPLATE_DETAIL_SUCCESS = "FETCH_TEMPLATE_DETAIL_SUCCESS";
export const FETCH_TEMPLATE_DETAIL_FAILURE = "FETCH_TEMPLATE_DETAIL_FAILURE";


// Segment API Endpoints
const SEGMENT_LIST_URL = "/framework/api/journeyBuilder/segments";
const SEGMENT_CREATE_URL = "/framework/api/journeyBuilder/create-segment";

// Schedule Journey API Endpoint
const SCHEDULE_JOURNEY_URL = "/framework/api/journeyBuilder/schedule-journey";

// Master List API Endpoint
const MASTER_LIST_URL = "/framework/api/journeyBuilder/master-list";

// Template API Endpoints
const TEMPLATE_LIST_URL = "/framework/api/emailCampaign";
const TEMPLATE_DETAIL_URL = "/framework/api/emailCampaign";

const SEND_TEST_EMAIL_URL = "/framework/api/journeyBuilder/sendTestMail";
const SEGMENT_DELETE_URL = "/framework/api/journeyBuilder/delete-segment";
const SEGMENT_PUBLISH_URL = "/framework/api/journeyBuilder/publish-segment";
const SEGMENT_COPY_URL = "/framework/api/journeyBuilder/copy-segment";
const SEGMENT_GET_URL = "/framework/api/journeyBuilder/edit-segment";
const COUNT_USER_URL = "/framework/api/journeyBuilder/segmentFilterData";

const JOURNEY_COPY_URL = "/framework/api/journeyBuilder/copyJourney";
const FILTER_DROPDOWN_DATA_URL = "/framework/api/journeyBuilder/segmentDropDown";



// Pagination Action Creators
export const setCurrentPage = (page) => ({
  type: SET_CURRENT_PAGE,
  payload: page
});

export const setItemsPerPage = (itemsPerPage) => ({
  type: SET_ITEMS_PER_PAGE,
  payload: itemsPerPage
});

export const setSearchTerm = (searchTerm) => ({
  type: SET_SEARCH_TERM,
  payload: searchTerm
});

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: filters
});

export const clearFilters = () => ({
  type: CLEAR_FILTERS
});

// ---------------------- Fetch Listing ----------------------
export const fetchListingData = (authToken, page = 1, limit = 10) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const response = await storeApis.get(JOURNEY_LIST_URL, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        params: {
          page: page,
          limit: limit
        }
      });

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          // Handle the correct API response structure
          const allJourneyData = response.data.data || response.data.details || [];
          const apiPagination = response.data.pagination || {};
          
          // Use API pagination data if available, otherwise calculate client-side
          const totalRecords = apiPagination.total_records || allJourneyData.length;
          const totalPages = apiPagination.total_pages || Math.ceil(totalRecords / limit);
          const currentPage = apiPagination.current_page || page;
          
          // If API provides pagination, use the data as-is, otherwise implement client-side pagination
          let paginatedData = allJourneyData;
          if (!apiPagination.total_pages && allJourneyData.length > limit) {
            const startIndex = (page - 1) * limit;
            const endIndex = startIndex + limit;
            paginatedData = allJourneyData.slice(startIndex, endIndex);
          }
          
          dispatch({
            type: FETCH_JOURNEY_DATA,
            payload: {
              data: paginatedData,
              allData: allJourneyData, // Store all data for pagination
              pagination: {
                currentPage: currentPage,
                totalPages: totalPages,
                totalRecords: totalRecords,
                limit: apiPagination.per_page || limit
              }
            },
          });
        }
      } else {
        toast.error("Failed to fetch journeys");
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
      window.scrollTo(0, 0);
    }
  };
};

// ---------------------- Client-side Pagination ----------------------
export const changePage = (page, limit = 10) => {
  return (dispatch, getState) => {
    const state = getState();
    const allData = state.journey.all_journey_data || [];
    const totalRecords = allData.length;
    const totalPages = Math.ceil(totalRecords / limit);
    
    // Implement client-side pagination
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = allData.slice(startIndex, endIndex);
    
    dispatch({
      type: FETCH_JOURNEY_DATA,
      payload: {
        data: paginatedData,
        allData: allData, // Keep all data for future pagination
        pagination: {
          currentPage: page,
          totalPages: totalPages,
          totalRecords: totalRecords,
          limit: limit
        }
      },
    });
  };
};

// ---------------------- Fetch Details ----------------------
export const fetchDetalil = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const response = await storeApis.post(
        JOURNEY_DETAIL_URL,
        { journey_id: id },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          dispatch({
            type: FETCH_JOURNEY_DETAIL,
            payload: response.data.details || [],
          });
        }
      } else {
        toast.error("Failed to fetch journey details");
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
      window.scrollTo(0, 0);
    }
  };
};

// ---------------------- Delete Journey ----------------------
export const deleteJourney = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_JOURNEY_DATA, payload: true });

    try {
      const response = await storeApis.post(
        JOURNEY_DELETE_URL,
        { jb_id: id },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        const apiStatusCode = String(response?.data?.statusCode || "");
        const apiStatus = response?.data?.status;
        const apiMessage = response?.data?.message;

        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(apiMessage || "Unauthorized", { toastId: 'auth-error' });
        } else if (apiStatusCode === "200" || apiStatus === "Success") {
          dispatch({
            type: DELETE_JOURNEY_DATA,
            payload: response.data.details || [],
          });
          toast.success(apiMessage || "Journey deleted successfully");
        } else {
          toast.error(apiMessage || "Failed to delete journey");
        }
      } else {
        toast.error("Failed to delete journey");
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
      window.scrollTo(0, 0);
    }
  };
};

// ---------------------- Update Journey ----------------------
export const updateJourney = (authToken, id, journeyData) => {
  return async (dispatch) => {
    dispatch({ type: JOURNEY_UPDATE_REQUEST });

    try {
      const response = await storeApis.post(
        JOURNEY_UPDATE_URL,
        {
          journey_id: id,
          edges: journeyData.edges,
          nodes: journeyData.nodes,
          metadata: journeyData.metadata,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200 && response.statusCode !== "400") {
        const apiStatusCode = String(response?.data?.statusCode || "");
        const apiStatus = response?.data?.status;
        const apiMessage = response?.data?.message;
        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(apiMessage || "Unauthorized", { toastId: 'auth-error' });
        } else if (apiStatusCode !== "200" || apiStatus === "Error") {
          // Treat any non-200 application status as failure even if HTTP is 200
          dispatch({ type: JOURNEY_UPDATE_FAILURE });
          toast.error(apiMessage || "Failed to update journey");
        } else {
          dispatch({
            type: JOURNEY_UPDATE_SUCCESS,
            payload: response.data.details || [],
          });
          toast.success(apiMessage || "Journey Created Successfully.");
        }
      } else {
        dispatch({ type: JOURNEY_UPDATE_FAILURE });
        toast.error("Failed to update journey");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: JOURNEY_UPDATE_FAILURE });
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
      window.scrollTo(0, 0);
    }
  };
};


// ---------------------- Create Journey ----------------------
export const createJourney = (authToken, id, journeyData) => {
  return async (dispatch) => {
    dispatch({ type: JOURNEY_CREATE_REQUEST });

    try {
      const response = await storeApis.post(
        JOURNEY_CREATE_URL,
        {
          title: journeyData.title,
          segment: journeyData.segment,
          thumbnail: journeyData.thumbnail,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      
      if (response.status === 200 && response.statusCode !== "400") {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          dispatch({
            type: JOURNEY_UPDATE_SUCCESS,
            payload: response.data.details || [],
          });
          toast.success("Journey Created Successfully.");
        }
      } else {
        dispatch({ type: JOURNEY_UPDATE_FAILURE });
        toast.error("Failed to update journey");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: JOURNEY_UPDATE_FAILURE });
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
      window.scrollTo(0, 0);
    }
  };
};

// ---------------------- Fetch Segments ----------------------
export const fetchSegments = (authToken, page = 1, limit = 10, search = "") => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SEGMENTS_REQUEST });

    try {
      // Build query parameters for server-side pagination
      const params = new URLSearchParams();
      params.append('page', page.toString());
      params.append('limit', limit.toString());
      if (search && search.trim()) {
        params.append('search', search.trim());
      }

      const response = await storeApis.get(`${SEGMENT_LIST_URL}?${params.toString()}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          dispatch({
            type: FETCH_SEGMENTS_SUCCESS,
            payload: response.data.details || [],
          });
          
          // Use pagination data from API response
          const paginationData = response.data.pagination;
          
          if (paginationData) {
            // Only update total items and pages for segments, not current page or items per page
            // to avoid triggering useEffect loops
            dispatch({
              type: UPDATE_SEGMENT_PAGINATION_TOTALS,
              payload: {
                totalItems: paginationData.total_records,
                totalPages: paginationData.total_pages
              }
            });
            
            
          }
        }
      } else {
        dispatch({ type: FETCH_SEGMENTS_FAILURE });
        toast.error("Failed to fetch segments");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: FETCH_SEGMENTS_FAILURE });
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };
};

// Get single segment by ID
export const getSegment = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: GET_SEGMENT_REQUEST });

    try {
      const response = await storeApis.post(
        SEGMENT_GET_URL,
        { id: id },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          const segmentData = response.data.details || response.data;
          dispatch({
            type: GET_SEGMENT_SUCCESS,
            payload: segmentData,
          });
        }
      } else {
        dispatch({ type: GET_SEGMENT_FAILURE });
        toast.error("Failed to fetch segment");
      }
    } catch (err) {
      console.error("API Error:", err);
      console.error("API Error:", err);
      dispatch({ type: GET_SEGMENT_FAILURE });
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };
};

// ---------------------- Create Segment ----------------------
export const createSegment = (authToken, segmentData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_SEGMENT_REQUEST });
    try {
      let requestPayload;
      
      // Pass-through formats for specific channels
      if (
        (segmentData.channel === 'PartnerLeads' && segmentData.filter && segmentData.filter.leads) ||
        (segmentData.channel === 'Contacts' && segmentData.filter && segmentData.filter.contacts)
      ) {
        // Send the payload as-is to preserve channel-specific filter structures
        requestPayload = segmentData;
      } else {
        // Old format - use the existing structure
        requestPayload = {
          action: segmentData.action,
          id: segmentData.id,
          segment_name: segmentData.segment_name,
          partner_category: segmentData.partner_category,
          master_data_list: segmentData.master_data_list,
          channel: segmentData.channel,
          source: segmentData.source,
          filter: segmentData.selectedfilters,
          page_name: segmentData.page_name,
          is_autoemail: segmentData.is_autoemail
        };
      }

      const response = await storeApis.post(
        SEGMENT_CREATE_URL,
        requestPayload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
          return { success: false, error: "Unauthorized" };
        } else if (response.data.statusCode === "400" || response.data.status === "Failed") {
          // Handle validation errors
          dispatch({ type: CREATE_SEGMENT_FAILURE });
          
          // Create a single consolidated error message
          let errorMessage = response.data.message || "Validation failed";
          
          // Add specific validation errors if available
          if (response.data.details) {
            const validationErrors = Object.values(response.data.details).flat();
            if (validationErrors.length > 0) {
              errorMessage = validationErrors.join(", ");
            }
          }
          
          // Show only one error message
          toast.error(errorMessage);
          
          return { success: false, error: errorMessage, details: response.data.details };
        } else {
          dispatch({
            type: CREATE_SEGMENT_SUCCESS,
            payload: response.data.details || [],
          });
          toast.success("Segment Saved Successfully");
          return { success: true, payload: response.data };
        }
      } else {
        dispatch({ type: CREATE_SEGMENT_FAILURE });
        // Don't show generic error message here - let the validation error handling above show specific errors
        return { success: false, error: "Failed to create segment" };
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: CREATE_SEGMENT_FAILURE });
      toast.error(err?.response?.data?.message || "Something went wrong");
      return { success: false, error: err?.response?.data?.message || "Something went wrong" };
    }
  };
};

// ---------------------- Schedule Journey ----------------------
export const scheduleJourney = (authToken, journeyId, scheduleData) => {
  return async (dispatch) => {
    dispatch({ type: SCHEDULE_JOURNEY_REQUEST });

    try {
      const response = await storeApis.post(
        SCHEDULE_JOURNEY_URL,
        {
          journey_id: journeyId,
          start_date: scheduleData.start_date,
          end_date: scheduleData.end_date,
          publish: scheduleData.publish
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        const apiStatusCode = String(response?.data?.statusCode || "");
        const apiStatus = response?.data?.status;
        
        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized");
        } else if (apiStatusCode === "200" && apiStatus === "Success") {
          dispatch({
            type: SCHEDULE_JOURNEY_SUCCESS,
            payload: response.data.details || [],
          });
          // Choose message based on whether start_date is present (schedule) or not (un-schedule)
          const isUnSchedule = !scheduleData?.start_date;
          const fallbackMessage = isUnSchedule 
            ? "Journey Un-Scheduled Successfully" 
            : "Journey Scheduled Successfully";
          toast.success(response.data?.message || fallbackMessage);
        } else {
          // Handle other status codes as failure
          dispatch({
            type: SCHEDULE_JOURNEY_FAILURE,
            payload: response.data,
          });
          toast.error(response.data.message || "Failed to schedule journey");
        }
      } else {
        dispatch({ type: SCHEDULE_JOURNEY_FAILURE });
        toast.error("Failed to schedule journey");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: SCHEDULE_JOURNEY_FAILURE });
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };
};

// ---------------------- Fetch Master List ----------------------
export const fetchMasterList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_MASTER_LIST_REQUEST });

    try {
      const response = await storeApis.get(
        MASTER_LIST_URL,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized");
        } else {
          dispatch({ type: FETCH_MASTER_LIST_SUCCESS, payload: response.data.details || [] });
        }
      } else {
        dispatch({ type: FETCH_MASTER_LIST_FAILURE });
        toast.error("Failed to fetch master list");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: FETCH_MASTER_LIST_FAILURE });
      toast.error(err?.response?.data?.message || "Failed to fetch master list");
    }
  };
};

// ---------------------- Fetch Templates List ----------------------
export const fetchTemplates = (authToken, payload = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TEMPLATES_REQUEST });

    try {
      const defaultPayload = {
        action: "select_template",
        filter: "all",
        search: "",
        page: 1,
        limit: 50,
        ...payload
      };

      const response = await storeApis.post(
        TEMPLATE_LIST_URL,
        defaultPayload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

        if (response.status === 200) {
         if (response.data.statusCode === "403") {
           dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
           toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
                   } else {
            // The API response structure is: { response: { count: 40, records: [...] } }
            const templates = response.data.response?.records || response.data.details || [];
            if (templates.length > 0) {
            }
            dispatch({
              type: FETCH_TEMPLATES_SUCCESS,
              payload: templates,
            });
          }
       } else {
        dispatch({ type: FETCH_TEMPLATES_FAILURE });
        toast.error("Failed to fetch templates");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: FETCH_TEMPLATES_FAILURE });
      toast.error(err?.response?.data?.message || "Failed to fetch templates");
    }
  };
};

export const whatsAppTemplateList = (authToken, payload = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_WHATSAPP_TEMPLATE_LIST_REQUEST });

    try {
      const response = await storeApis.post(
        WHATSAPP_TEMPLATE_LIST_URL,
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          // The API response structure is: { response: { count: 40, records: [...] } }
          const templates = response.data.response?.records || response.data.details || [];
          if (templates.length > 0) {
          }
          dispatch({
            type: FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS,
            payload: templates,
          });
        }
      } else {
        dispatch({ type: FETCH_WHATSAPP_TEMPLATE_LIST_FAILURE });
        toast.error("Failed to fetch WhatsApp templates");
      }
    } catch (err) {
      console.error("WhatsApp Template API Error:", err);
      dispatch({ type: FETCH_WHATSAPP_TEMPLATE_LIST_FAILURE });
      toast.error(err?.response?.data?.message || "Failed to fetch WhatsApp templates");
    }
  };
};



// ---------------------- Fetch Template Details ----------------------
export const fetchTemplateDetail = (authToken, campId, isNew = 1) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TEMPLATE_DETAIL_REQUEST });

    try {
      const payload = {
        action: "edit_campaign",
        camp_id: campId,
        is_new: isNew
      };

      const response = await storeApis.post(
        TEMPLATE_DETAIL_URL,
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          dispatch({
            type: FETCH_TEMPLATE_DETAIL_SUCCESS,
            payload: response.data.details || {},
          });
        }
      } else {
        dispatch({ type: FETCH_TEMPLATE_DETAIL_FAILURE });
        toast.error("Failed to fetch template details");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: FETCH_TEMPLATE_DETAIL_FAILURE });
      toast.error(err?.response?.data?.message || "Failed to fetch template details");
    }
  };
};

// ---------------------- Send Test Email ----------------------
export const sendTestEmail = (authToken, emailData) => {
  return async (dispatch) => {
    dispatch({ type: SEND_TEST_EMAIL_REQUEST });

    try {
      const payload = {
        template_id: emailData.template,
        campaign_name: emailData.campaignName,
        campaign_tags: emailData.campaignTags,
        email: emailData.testEmail
      };

      const response = await storeApis.post(
        SEND_TEST_EMAIL_URL,
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized");
        } else if (response.data.statusCode === "200" || response.data.status === "Success") {
          dispatch({
            type: SEND_TEST_EMAIL_SUCCESS,
            payload: response.data.details || response.data,
          });
          toast.success("Test email sent successfully!");
        } else {
          // Handle API error responses (like statusCode: "400")
          dispatch({ type: SEND_TEST_EMAIL_FAILURE });
          toast.error(response.data.message || "Failed to send test email");
        }
      } else {
        dispatch({ type: SEND_TEST_EMAIL_FAILURE });
        toast.error("Failed to send test email");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: SEND_TEST_EMAIL_FAILURE });
      toast.error(err?.response?.data?.message || "Failed to send test email");
    }
  };
};


// ---------------------- Segment Deleted. ----------------------
export const deleteSegment = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    try {
      const response = await storeApis.post(
        SEGMENT_DELETE_URL,
        { segment_id: id },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        const apiStatusCode = String(response?.data?.statusCode || "");
        const apiStatus = response?.data?.status;
        const apiMessage = response?.data?.message;

        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(apiMessage || "Unauthorized", { toastId: 'auth-error' });
          return { success: false, error: apiMessage || "Unauthorized" };
        }

        if (apiStatusCode === "200" || apiStatus === "Success") {
          dispatch({ type: DELETE_SEGMENT_DATA, payload: id });
          toast.success(apiMessage || "Segment deleted successfully");
          return { success: true, payload: response.data };
        }

        // Any other application-level failure
        toast.error(apiMessage || "Failed to delete segment.");
          return { success: false, error: apiMessage || "Failed to delete segment." };
        } else {
          toast.error("Failed to delete segment.");
          return { success: false, error: "Failed to delete segment." };
        }
      } catch (err) {
        const errorMessage = err?.response?.data?.message || 
                           err?.response?.data?.exception || 
                           `Request failed with status ${err?.response?.status || 'Unknown'}`;
        toast.error(errorMessage);
        return { success: false, error: errorMessage };
      } finally {
        dispatch({ type: TOGGLE_LOADING, payload: false });
        window.scrollTo(0, 0);
      }
    };
  };



export const copyJourney = (authToken, journeyData) => {
  return async (dispatch) => {
    dispatch({ type: COPY_JOURNEY_REQUEST });
    try {
      const response = await storeApis.post(
        JOURNEY_COPY_URL,
        journeyData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      
      if (response.status === 200) {
        const apiStatusCode = String(response?.data?.statusCode || "");
        const apiStatus = response?.data?.status;
        
        
        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized");
        } else if (apiStatusCode === "200" && apiStatus === "Success") {
          dispatch({
            type: COPY_JOURNEY_SUCCESS,
            payload: response.data,
          });
        } else {
          dispatch({
            type: COPY_JOURNEY_FAILURE,
            payload: response.data,
          });
        }
      } else {
        dispatch({
          type: COPY_JOURNEY_FAILURE,
          payload: { message: "Failed to copy journey" },
        });
      }
    } catch (error) {
      dispatch({
        type: COPY_JOURNEY_FAILURE,
        payload: error.response ? error.response.data : error.message,
      });
    }
  };
};


// ---------------------- publish Segment ----------------------
export const publishSegment = (authToken, id,publish) => {
  publish = publish === 'active' ? 'Inactive' : 'Active';
  return async (dispatch) => {
    dispatch({ type: PUBLISH_SEGMENT_DATA, payload: true });

    try {
      const response = await storeApis.post(
        SEGMENT_PUBLISH_URL,
        { segment_id: id,publish:publish },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized");
          return { success: false, error: response.data.message || "Unauthorized" };
        } else {
          dispatch({
            type: PUBLISH_SEGMENT_DATA,
            payload: response.data.details || [],
          });
          // Show message from API response
          toast.success(response.data.message || "Success");
          return { success: true, payload: response.data };
        }
      } else {
        return { success: false, error: "Failed to publish segment" };
      }
    } catch (err) {
      return { success: false, error: err?.response?.data?.message || err?.message};
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
      window.scrollTo(0, 0);
    }
  };
};


export const copySegment = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: COPY_SEGMENT_DATA, payload: true });
    try {
      const response = await storeApis.post(
        SEGMENT_COPY_URL,
        { segment_id: id },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      
      if (response.status === 200) {
        const apiStatusCode = String(response?.data?.statusCode || "");
        const apiStatus = response?.data?.status;
        const apiMessage = response?.data?.message;

        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(apiMessage || "Unauthorized");
          return { success: false, error: apiMessage || "Unauthorized" };
        }

        if (response.data.success || apiStatusCode === "200" || apiStatus === "Success") {
          toast.success(apiMessage || "Segment copied successfully");
          return { success: true, payload: response.data };
        }

        toast.error(apiMessage || "Failed to copy segment");
        return { success: false, error: apiMessage || "Failed to copy segment" };
      }
      toast.error("Failed to copy segment");
      return { success: false, error: "Failed to copy segment" };
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to copy segment");
      return { success: false, error: err?.response?.data?.message || err?.message};
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
      window.scrollTo(0, 0);
    }
  };
};

// ✅ Count Users Action
export const countUsers = (authToken, segmentData) => {
  return async (dispatch) => {
    try {
      const isDownload = segmentData.action === "download";
      // Only dispatch COUNT_USERS_REQUEST for "update" action, not for "download"
      if (!isDownload) {
        dispatch({ type: COUNT_USERS_REQUEST });
      }
      let requestPayload;
      if (
        (segmentData.channel === 'PartnerLeads' && segmentData.filter && segmentData.filter.leads) ||
        (segmentData.channel === 'Contacts' && segmentData.filter && segmentData.filter.contacts)
      ) {
        // Send the payload as-is to preserve channel-specific filter structures
        requestPayload = segmentData;
      } else {
        // Old format - use the existing structure
        requestPayload = {
          action: segmentData.action,
          id: segmentData.id,
          segment_name: segmentData.segment_name,
          partner_category: segmentData.partner_category,
          master_data_list: segmentData.master_data_list,
          channel: segmentData.channel,
          source: segmentData.source,
          filter: segmentData.selectedfilters,
          page_name: segmentData.page_name,
          is_autoemail: segmentData.is_autoemail
        };
      }
      
      const response = await storeApis.post(
        COUNT_USER_URL,
        requestPayload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          responseType: 'json',
        }
      );

      // Handle download response
      if (isDownload) {
        if (response.status === 200 && response.data) {
          try {
            // Check if response.data is an error object
            if (response.data.statusCode === "403" || response.data.statusCode === 403) {
              const errorMsg = response.data.message || "Failed to download file";
              // Don't dispatch COUNT_USERS_FAILURE for download action to avoid affecting Total Users display
              toast.error(errorMsg);
              return { success: false, error: errorMsg };
            }

            // Import xlsx library dynamically
            const XLSX = await import("xlsx");
            
            let csvData = response.data;
            
            // If response.data is a string (CSV), use it directly
            // If it's an object, check if it has a data property or convert to CSV
            if (typeof csvData === 'object' && csvData !== null) {
              // If it's an object with a data property containing CSV string
              if (csvData.data && typeof csvData.data === 'string') {
                csvData = csvData.data;
              } else if (csvData.response && typeof csvData.response === 'string') {
                csvData = csvData.response;
              } else if (Array.isArray(csvData)) {
                // If it's an array, convert to Excel directly
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(csvData);
                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                
                const filename = segmentData.segment_name 
                  ? `${segmentData.segment_name}_export.xlsx` 
                  : `segment_export_${Date.now()}.xlsx`;
                
                XLSX.writeFile(workbook, filename);
                toast.success("Excel file downloaded successfully");
                return { success: true };
              } else {
                // If it's an object, convert to Excel directly
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet([csvData]);
                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                
                const filename = segmentData.segment_name 
                  ? `${segmentData.segment_name}_export.xlsx` 
                  : `segment_export_${Date.now()}.xlsx`;
                
                XLSX.writeFile(workbook, filename);
                toast.success("Excel file downloaded successfully");
                return { success: true };
              }
            }
            
            // Convert CSV string to Excel workbook using XLSX's built-in CSV parser
            const csvWorkbook = XLSX.read(csvData, { type: 'string' });
            const firstSheetName = csvWorkbook.SheetNames[0];
            const csvWorksheet = csvWorkbook.Sheets[firstSheetName];
            
            // Create new workbook with the parsed CSV data
            const newWorkbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(newWorkbook, csvWorksheet, "Sheet1");
            
            // Generate filename
            const filename = segmentData.segment_name 
              ? `${segmentData.segment_name}_export.xlsx` 
              : `segment_export_${Date.now()}.xlsx`;
            
            // Write and download the file
            XLSX.writeFile(newWorkbook, filename);
            
            toast.success("Excel file downloaded successfully");
            return { success: true };
          } catch (error) {
            console.error("Error processing download:", error);
            const errorMsg = error?.message || "Failed to download file";
            dispatch({ type: COUNT_USERS_FAILURE, payload: errorMsg });
            toast.error(errorMsg);
            return { success: false, error: errorMsg };
          }
        } else {
          throw new Error("Failed to download file");
        }
      }

      // Handle update response (existing logic)
      // Handle empty/invalid responses safely
      if (!response || response === '' || !response.data) {
        const emptyMsg = "No response from server. Please try again.";
        dispatch({ type: COUNT_USERS_FAILURE, payload: emptyMsg });
        toast.error(emptyMsg);
        return { success: false, error: emptyMsg };
      }
      // Handle unauthorized explicitly if API uses statusCode on 200 HTTP
      if (String(response?.data?.statusCode || "") === "403") {
        const msg = response?.data?.message || "Unauthorized";
        dispatch({ type: COUNT_USERS_FAILURE, payload: msg });
        toast.error(msg, { toastId: 'auth-error' });
        return { success: false, error: msg };
      }
      if (response?.data?.status === 'Success') {
        dispatch({ 
          type: COUNT_USERS_SUCCESS, 
          payload: response.data.details.count 
        });
        return { success: true, count: response.data.details.count };
      } else {
        throw new Error(response.data.message || "Failed to count users");
      }
    } catch (error) {
      const statusCode = error?.response?.status;
      const isDownload = segmentData.action === "download";
      let errorMessage = "Failed to count users";
      
      // Handle blob error responses for download
      if (isDownload && error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          errorMessage = errorData.message || errorData.error || "Failed to download file";
        } catch (e) {
          errorMessage = error?.response?.data?.message || error?.message || "Failed to download file";
        }
      } else {
        errorMessage = error?.response?.data?.message || error?.message || "Failed to count users";
      }
      
      if (statusCode === 500) {
        errorMessage = "We're having trouble counting users right now. Please try again later.";
      }
      // Only dispatch COUNT_USERS_FAILURE for "update" action, not for "download"
      if (!isDownload) {
        dispatch({ 
          type: COUNT_USERS_FAILURE, 
          payload: errorMessage 
        });
      }
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  };
};

// ---------------------- Fetch Segment Filter Dropdown Data ----------------------
export const filterDropdownData = (authToken) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FILTER_DROPDOWN_DATA });  
      const response = await storeApis.post(
        FILTER_DROPDOWN_DATA_URL,
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );


      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized");
          dispatch({ type: FILTER_DROPDOWN_DATA_FAILURE, payload: response.data.message || "Unauthorized" });
        } else {
          const dropdowns = response.data.details || response.data;
          dispatch({ type: FILTER_DROPDOWN_DATA_SUCCESS, payload: dropdowns });
        }
      } else {
        dispatch({ type: FILTER_DROPDOWN_DATA_FAILURE, payload: "Failed to fetch filter dropdowns" });
        toast.error("Failed to fetch filter dropdowns");
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || "Failed to fetch filter dropdowns";
      dispatch({ type: FILTER_DROPDOWN_DATA_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
    }
  };
};

// ---------------------- Update WhatsApp Template ----------------------
export const updateWhatsappTemplate = (authToken, payload) => {
  // payload fields expected: wp_id/title, description, jb_id, type, image { base64, file { name,size,type }, videoFile }
  return async (dispatch) => {
    dispatch({ type: WHATSAPP_TEMPLATE_UPDATE_REQUEST });
console.log("payload", payload);
    try {
      // Use same JSON payload format for all file types (image, pdf, video)
      const requestPayload = {
        wp_id: payload?.wp_id ?? payload?.wp_id ?? payload?.template_id ?? "",
        title: payload?.title ?? payload?.template_name ?? "",
        description: payload?.description ?? "",
        jb_id: payload?.jb_id ?? "",
        node_id: payload?.node_id ?? "",
        type: payload?.type ?? "whatsapp",
        image: payload?.image || null,
        link: payload?.link || "",
        image_removed: payload?.image_removed || 0,
        file_type: payload?.file_type || null
      };

      const response = await storeApis.post(
        WHATSAPP_TEMPLATE_UPDATE_URL,
        requestPayload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        const apiStatusCode = String(response?.data?.statusCode || "");
        const apiStatus = response?.data?.status;
        const apiMessage = response?.data?.message;
        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(apiMessage || "Unauthorized");
          dispatch({ type: WHATSAPP_TEMPLATE_UPDATE_FAILURE, payload: apiMessage || "Unauthorized" });
          return response?.data;
        } else if (apiStatusCode === "200" || apiStatus === "Success") {
          dispatch({ type: WHATSAPP_TEMPLATE_UPDATE_SUCCESS, payload: response.data.details || response.data });
          toast.success(apiMessage || "WhatsApp template updated successfully");
          return response?.data;
        } else {
          dispatch({ type: WHATSAPP_TEMPLATE_UPDATE_FAILURE, payload: apiMessage || "Failed to update" });
          toast.error(apiMessage || "Failed to update WhatsApp template");
          return response?.data;
        }
      } else {
        dispatch({ type: WHATSAPP_TEMPLATE_UPDATE_FAILURE, payload: "Failed to update WhatsApp template" });
        toast.error("Failed to update WhatsApp template");
        return { statusCode: String(response?.status || 0), status: "Error", message: "Failed to update WhatsApp template" };
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || "Failed to update WhatsApp template";
      dispatch({ type: WHATSAPP_TEMPLATE_UPDATE_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      return err?.response?.data || { status: "Error", message: errorMessage };
    }
  };
};


// ---------------------- Fetch Template Details ----------------------
export const notificationDetailList = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: NOTIFICATION_DETAIL_LIST_REQUEST });

    try {
      const payload = {
        jb_id: id,
       };

      const response = await storeApis.post(
        NOTIFICATION_DETAIL_LIST_URL,
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          toast.error(response.data.message || "Unauthorized", { toastId: 'auth-error' });
        } else {
          dispatch({
            type: NOTIFICATION_DETAIL_LIST_SUCCESS,
            payload: response.data.details || {},
          });
        }
      } else {
        dispatch({ type: NOTIFICATION_DETAIL_LIST_FAILURE });
        toast.error("Failed to fetch template details");
      }
    } catch (err) {
      console.error("API Error:", err);
      dispatch({ type: NOTIFICATION_DETAIL_LIST_FAILURE });
      toast.error(err?.response?.data?.message || "Failed to fetch notification details");
    }
  };
};

export const verifiedEmailList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_VERIFIED_EMAIL_LIST_REQUEST });
    try {
      const response = await storeApis.post(
        VERIFIED_EMAIL_LIST_URL,
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        const apiStatusCode = String(response?.data?.statusCode || "");
        if (apiStatusCode === "403") {
          dispatch({ type: UNAUTHORIZED_SETUP, payload: response.data.statusCode });
          dispatch({ type: FETCH_VERIFIED_EMAIL_LIST_FAILURE, payload: response?.data?.message || "Unauthorized" });
          toast.error(response?.data?.message || "Unauthorized");
          return { success: false, error: response?.data?.message || "Unauthorized" };
        }

        // Normalize payload to { from: string[], reply: string[] }
        const detailsRoot = response?.data?.details?.data || response?.data?.details || response?.data?.data || {};
        const from = Array.isArray(detailsRoot?.from) ? detailsRoot.from : [];
        const reply = Array.isArray(detailsRoot?.reply) ? detailsRoot.reply : [];
        const list = { from, reply };

        dispatch({ type: FETCH_VERIFIED_EMAIL_LIST_SUCCESS, payload: list });
        return { success: true, payload: list };
      } else {
        dispatch({ type: FETCH_VERIFIED_EMAIL_LIST_FAILURE, payload: "Failed to fetch verified email list" });
        toast.error("Failed to fetch verified email list");
        return { success: false, error: "Failed to fetch verified email list" };
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || "Failed to fetch verified email list";
      dispatch({ type: FETCH_VERIFIED_EMAIL_LIST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  };
};
